import styled from 'styled-components';

const Message = styled.span`
  font-size: ${props => props.fontSize};
`;

Message.defaultProps = {
  fontSize: '1.6em'
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/common/Snackbar/Message.js